import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M23 3.5 38.5 19 31 26.5 15.5 11 23 3.5ZM14 11l9-9 17 16.97L31 28 14 11Zm-7 5.5h6.8l17.21 17.197 5.344-5.343-.708-.707-4.656 4.656L14.198 15.5H7v1Zm3 6H0v-1h10v1Zm6 6H6v-1h10v1Zm10.414 6.086a2 2 0 1 0 0 2.828 2 2 0 0 0 0-2.828Zm.707 3.535a3 3 0 1 0-4.242-4.243 3 3 0 0 0 4.242 4.243Z",
    fill: "#828282"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h40v40H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }